/**
 * @generated SignedSource<<52a2f597aaead26ac540156fd17879ed>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginHeaderQuery$variables = {
  subdomain: string;
};
export type LoginHeaderQuery$data = {
  readonly publicBuilding: {
    readonly name: string;
  } | null | undefined;
  readonly publicLicense: {
    readonly logoPath: string | null | undefined;
    readonly name: string;
  } | null | undefined;
};
export type LoginHeaderQuery = {
  response: LoginHeaderQuery$data;
  variables: LoginHeaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subdomain"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "subdomain",
    "variableName": "subdomain"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoPath",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PublicLicense",
        "kind": "LinkedField",
        "name": "publicLicense",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PublicBuilding",
        "kind": "LinkedField",
        "name": "publicBuilding",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LoginHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PublicLicense",
        "kind": "LinkedField",
        "name": "publicLicense",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PublicBuilding",
        "kind": "LinkedField",
        "name": "publicBuilding",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c8a5910742aa4e9001772974e76981f",
    "id": null,
    "metadata": {},
    "name": "LoginHeaderQuery",
    "operationKind": "query",
    "text": "query LoginHeaderQuery(\n  $subdomain: String!\n) {\n  publicLicense(subdomain: $subdomain) {\n    name\n    logoPath\n    id\n  }\n  publicBuilding(subdomain: $subdomain) {\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2446a1b5e58e823ba32ff376c7ee5ff2";

export default node;
